import { css } from '@linaria/core';
import { styled } from '@linaria/react';
import ReactSlider from 'react-slider';

import { Captions, Text } from '~components/Typography';
import { CardButton } from '~shared/ui/organisms/CardButton';
import { MqTablet } from '~theme/media';

export const StyledFieldSliders = styled.div`
	width: 100%;
`;

export const Description = styled(Text)`
	display: flex;
	height: 40px;
	align-items: center;
	justify-content: center;
	margin-top: 24px;
`;

export const mobileHidden = css`
	display: none;
	${MqTablet} {
		display: flex;
	}
`;

export const desktopHidden = css`
	${MqTablet} {
		display: none;
	}
`;

export const SliderLabel = styled(Captions)`
	width: 50px;
	flex-shrink: 0;
`;

export const SliderWrapper = styled.div`
	display: flex;
	flex-grow: 1;
	gap: var(--gap-x4);
`;

export const StyledSlider = styled(ReactSlider)`
	width: 100%;
	height: 20px;
	align-items: center;
	justify-content: center;
`;

export const StyledTrack = styled.div<{ index: number }>`
	top: 8px;
	height: 4px;
	border-radius: var(--radius-s);
	background: ${(props) =>
		props.index === 2
			? 'var(--color-white-solid)'
			: props.index === 1
			? 'var(--color-white-m)'
			: 'var(--color-white-solid)'};
`;

export const Sliders = styled.div`
	display: flex;
	width: 100%;
	max-width: 384px;
	flex-direction: column;
	margin-top: 24px;
	margin-right: auto;
	margin-left: auto;
	gap: var(--gap-x4);
`;
export const StyledThumb = styled.div`
	top: 0;
	overflow: hidden;
	width: 18px;
	height: 18px;
	border: 4px solid var(--color-grey-10-solid);
	border-radius: var(--radius-xxs);
	background-color: var(--color-grey-95-solid);
	text-indent: 100%;
	white-space: nowrap;
`;

export const StyledCardButton = styled(CardButton)`
	width: 170px;

	${MqTablet} {
		width: 280px;
	}
`;
